import dotCommon from "../common/dot";

export const polimecDot = {
  id: 10,
  height: 1151155,
  ...dotCommon,
};

export default polimecDot;
